<template>
  <!-- eslint-disable vue/require-v-for-key, vue/no-use-v-if-with-v-for, vue/no-unused-vars -->
  <div class="wrapper-choose-product">
    <!-- Top Bar -->
    <div
      ref="wrapper-topbar"
      class="wrapper-topbar"
    >
      <div class="finding">
        <div
          v-if="display.search"
          class="search-input"
        >
          <input
            ref="txtfield-search"
            :placeholder="$t('placeholder.search')"
            v-model="txtFieldSearch"
            type="text"
            class="form-control form-control-sm"
          >
          <button
            class="btn btn-light btn-close"
            @click="handleClickCloseSearch"
          >
            <i class="fas fa-times"/>
          </button>
        </div>
        <template
          v-else
        >
          <div
            class="category"
            @click="handleClickCategoryList"
          >
            <span class="icon">
              <i class="fas fa-sitemap"/>
            </span>
            <span class="text">
              {{ selectedCategoryName }} ({{ selectedCategoryProductCount }})
            </span>
          </div>
          <div
            v-if="posSettings.menu_online.is_active"
            class="btn-icon"
            @click="handleClickNotificationIcon"
          >
            <span class="icon">
              <BaseNotificationBell
                :count="unreadNotificationCount"
              />
            </span>
          </div>
          <div
            v-if="posSettings.menu_online.is_active"
            class="btn-icon"
            @click="handleOpenCreateQRCodeForm"
          >
            <span class="icon">
              <i
                class="fas fa-qrcode"
                style="font-size: 18px;position: relative;top: 0px;"/>
            </span>
          </div>
          <div class="btn-icon">
            <vs-tooltip
              v-if="!isOffline"
              :text="bills.length > 0 ? $t('message.transactionswillsaveauto', {number: bills.length}) : networkMessage"
              position="bottom">
              <div
                v-if="bills.length > 0"
                class="sync-count">
                {{ bills.length }}
              </div>
              <a
                class="btn no-bg"
                style="cursor: default;">
                <i
                  class="fas fa-wifi"
                  style="font-size: 15px;"
                />
              </a>
            </vs-tooltip>
            <vs-tooltip
              v-if="isOffline"
              :text="bills.length > 0 ? $t('message.transactionswillsaveauto', {number: bills.length}) : networkMessage"
              position="bottom">
              <a
                class="btn no-bg"
                style="cursor: default;">
                <div
                  v-if="bills.length > 0"
                  class="sync-count">
                  {{ bills.length }}
                </div>
                <i
                  class="fas fa-wifi text-danger"
                  style="font-size: 15px;"
                />
              </a>
            </vs-tooltip>
          </div>
          <div
            v-if="showDiscountButton"
            class="btn-icon"
            @click="handleClickDiscountIcon"
          >
            <span class="icon">
              <i class="fas fa-tag"/>
            </span>
          </div>
          <div
            class="btn-icon"
            @click="handleClickSearchIcon"
          >
            <span class="icon">
              <i class="fas fa-search"/>
            </span>
          </div>
        </template>
      </div>
    </div>

    <!-- Product List -->
    <div
      :style="[
        { height: `${wrapperScrollableHeight}px` }
      ]"
      class="wrapper-scrollable"
    >
      <div
        v-if="!display.search"
        class="wrapper-sections"
      >
        <QueueButton
          v-if="use_queue"
          :loaded="loaded"
          class="btn-queue"/>

        <TableButton
          v-if="use_table"
          class="btn-table"/>

        <DiningButton
          v-if="use_dining"
          class="btn-dining"/>

        <CustomerButton
          v-if="user_customer"
          class="btn-customer"
        />
      </div>

      <div
        v-for="(item, index) in filterProducts"
        v-if="item.category_id == category_id"
        :key="index"
        class="wrapper-products"
        style="height: 100%;"
      >
        <RecycleScroller
          :items="item.products"
          :itemSize="80"
          keyField="product_id"
          class="scroller"
        >
          <template #default="{ item: product, index: productIndex }">
            <div
              :class="[{'disabled': isSinglePriceAndIsNotAvailable(product) || isSinglePriceAndOutOfStock(product)}]"
              :key="productIndex"
              class="product"
              style="width: 100%;"
              @click="selectedProduct(product)"
            >
              <div class="image">
                <img :src="product.images.thumbnail || defaultImages.product">
              </div>
              <div class="detail">
                <div class="info">
                  <span class="name">
                    {{ product.product_name }}
                  </span>
                  <span class="icons">
                    <!-- Stock Balance -->
                    <vs-tooltip
                      v-if="isSyncWithWarehouse(product)"
                      :text="$t('apps.inventory.message.stockquantity').toLowerCase()"
                      position="top"
                      style="float: left;margin: 0 2px;"
                    >
                      <span
                        class="badge badge-secondary"
                        style="height: 16px; display: flex; align-items: center; justify-content: center; font-size: 9px;position: relative;top: -1px; height: 15px;margin-left: -1px;"
                      >
                        <i
                          class="fas fa-box-open"
                          style="margin-right: 2px;"/>
                        {{ stockCount(product) }}
                      </span>
                    </vs-tooltip>
                    <!-- Custom Price -->
                    <vs-tooltip
                      v-if="isCustomPrice(product) && !isSinglePriceAndIsNotAvailable(product) && !isSinglePriceAndOutOfStock(product)"
                      :text="$t('message.customprice').toLowerCase()"
                      position="top"
                      style="float: left;margin: 0 3px;cursor: pointer;"
                    >
                      <span
                        class="badge badge-secondary"
                        style="height: 16px; display: flex; align-items: center; justify-content: center; font-size: 9px;position: relative;top: -1px;height: 15px;"
                      >
                        <i class="fas fa-calculator"/>
                      </span>
                    </vs-tooltip>
                    <!-- Lot -->
                    <vs-tooltip
                      v-if="
                        !isCustomAttr(product) &&
                          isProductUseLot(product)
                      "
                      :text="$t('message.chooselot').toLowerCase()"
                      position="top"
                      style="float: left;margin: 0 2px;cursor: pointer;"
                    >
                      <span
                        v-if="isSyncWithWarehouse(product)"
                        class="badge badge-secondary"
                        style="height: 16px; display: flex; align-items: center; justify-content: center; font-size: 9px;position: relative;top: -1px;height: 15px;"
                      >
                        <i class="fas fa-pallet"/>
                      </span>
                    </vs-tooltip>
                    <!-- Serial -->
                    <vs-tooltip
                      v-if="
                        !isCustomAttr(product) &&
                          isProductUseSerial(product)
                      "
                      :text="$t('message.chooseserial').toLowerCase()"
                      position="top"
                      style="float: left;margin: 0 2px;cursor: pointer;"
                    >
                      <span
                        v-if="isSyncWithWarehouse(product)"
                        class="badge badge-secondary"
                        style="height: 16px; display: flex; align-items: center; justify-content: center; font-size: 9px;position: relative;top: -1px;height: 15px;"
                      >
                        <i class="fas fa-sd-card"/>
                      </span>
                    </vs-tooltip>
                    <!-- not available -->
                    <template>
                      <span
                        v-if="isSinglePriceAndIsNotAvailable(product)"
                        class="badge badge-danger"
                        style="font-size: 9px;position: relative;top: -1px;">
                        {{ $t('message.productisnotavailable') }}
                      </span>
                      <span
                        v-if="isSinglePriceAndOutOfStock(product)"
                        class="badge badge-danger"
                        style="font-size: 9px;position: relative;top: -1px;">
                        {{ $t('message.outofstock') }}
                      </span>
                    </template>
                  </span>
                </div>
                <div class="price">
                  <span v-if="isFixedPrice(product)">
                    {{ getNumber(product.prices[0].price) }}
                  </span>
                  <span v-else-if="isCustomPrice(product)">
                    <span class="comma">
                      {{ $t('message.variableprice') }}
                    </span>
                    <span
                      v-if="product.prices.length == 1 && product.modifiers.length > 0"
                      class="comma">
                      {{ $t('message.modifiers') }}
                    </span>
                  </span>
                  <span v-else>
                    <span
                      v-if="product.prices.length > 1"
                      class="comma">
                      {{ $t('apps.pos.message.prices', {number: product.prices.length}) }}
                    </span>
                    <span
                      v-if="product.modifiers.length > 0"
                      class="comma">
                      {{ $t('message.modifiers') }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </template>
        </RecycleScroller>
      </div>
    </div>

    <!-- Button Bar -->
    <div
      ref="wrapper-bottombar"
      class="wrapper-bottombar"
    >
      <div class="header">
        <button
          class="btn btn-light"
          @click="onBackToDashboard"
        >
          <i class="fas fa-power-off"/>
        </button>
        <PrintButton/>
        <button
          :class="[orderTotalClass]"
          :disabled="disabledViewOrders"
          class="btn btn-light btn-order-number"
          @click="handleClickOrderCount"
        >
          {{ ordersCountText }}
        </button>
        <TotalPriceButton
          disabled="false"
          class="btn-submit-order"
        />
      </div>
    </div>

    <!-- Modal Select Lot Number -->
    <BaseSelectLotNumberModal
      :show="lotModal.show"
      :loading="lotModal.loading"
      :lots="lotList"
      :selected="lot.selected"
      :index="0"
      :skuId="lot.skuId"
      @onClose="handleCloseLotModal"
      @onCancel="handleCancleLotModal"
      @onSubmit="handleSumitLotModal"
      @onSortChange="handleSortLotChange"
    />

    <!-- Modal Select Serial Number -->
    <BaseSelectSerialNumberModal
      :show="serialModal.show"
      :loading="serialModal.loading"
      :serials="serialList"
      :selected="serial.selected"
      :index="0"
      :skuId="serial.skuId"
      @onClose="handleCloseSerialModal"
      @onCancel="handleCancleSerialModal"
      @onSubmit="handleSumitSerialModal"
      @onSortChange="handleSortSerialChange"
    />

    <BaseBModalQRCodeForm
      :modalTitle="$t('apps.pos.message.createnewqrcode')"
      :formType="'create'"
      :isSubmitted="isSubmittedQRCodeForm"
      :branches="[branch]"
      :posSessions="[posSession]"
      :defaultValues="defaultValues"
      :qrcode="qrcode"
      @onSubmit="handleSubmitQRCodeForm"
    />

    <BaseBModalQRCodeImage
      :qrcode="qrcode"
    />
  </div>
</template>

<script>
import chooseProductMixin from '@/mixins/pos/chooseProduct'
import posSelectLotMixin from '@/mixins/posSelectLot'
import posSelectSerialMixin from '@/mixins/posSelectSerial'
import QueueButton from '../common/QueueButton.vue'
import PrintButton from '../common/PrintButton.vue'
import TotalPriceButton from '../common/TotalPriceButton'
import TableButton from '../common/TableButton.vue'
import DiningButton from '../common/DiningButton.vue'
import CustomerButton from '../common/CustomerButton.vue'
import BaseNotificationBell from '../../../../../base/BaseNotificationBell.vue'
import BaseBModalQRCodeForm from '../../../../../base/BaseBModalQRCodeForm.vue'
import BaseBModalQRCodeImage from '../../../../../base/BaseBModalQRCodeImage.vue'

export default {
  components: {
    QueueButton,
    PrintButton,
    TotalPriceButton,
    TableButton,
    DiningButton,
    CustomerButton,
    BaseNotificationBell,
    BaseBModalQRCodeForm,
    BaseBModalQRCodeImage,
  },

  mixins: [chooseProductMixin, posSelectLotMixin, posSelectSerialMixin],

  data() {
    return {
      wrapperScrollableHeight: 0,
    }
  },

  computed: {
    ordersByTableNumber() {
      return this.getPosOrdersById({
        queue_number: this.queue_number,
        table_number: this.table_number,
      })
    },
    ordersCount() {
      return this.ordersByTableNumber.reduce((acc, cur) => {
        return cur.quantity + acc
      }, 0)
    },
    ordersCountText() {
      return this.ordersCount > 9
        ? '9+'
        : this.ordersCount
    },
    orderTotalClass() {
      if (this.ordersCount > 9) {
        return 'text-md'
      } else if (this.ordersCount > 99) {
        return 'text-sm'
      }
      return null
    },
    selectedCategoryName() {
      if (this.category_id == '1') {
        return this.$t('message.favorite')
      } else if (this.category_id == '2') {
        return this.$t('apps.pos.message.allproducts')
      }
      return this.products.reduce((acc, cur) => {
        if (cur.category_id == this.category_id) {
          acc = cur.category_name
        }
        return acc
      }, '')
    },
    selectedCategoryProductCount() {
      return this.products.reduce((acc, cur) => {
        if (cur.category_id == this.category_id) {
          acc = cur.products.length
        }
        return acc
      }, 0)
    },
    disabledViewOrders() {
      return this.ordersCount === 0
    },
  },

  methods: {
    setUI() {
      const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      const wrapperTopbarHeight = (() => {
        const el = this.$refs['wrapper-topbar']
        return el
          ? el.clientHeight
          : 0
      })()
      const wrapperBottombarHeight = (() => {
        const el = this.$refs['wrapper-bottombar']
        return el
          ? el.clientHeight
          : 0
      })()
      const wrapperScrollableHeight = windowHeight - wrapperTopbarHeight - wrapperBottombarHeight
      this.wrapperScrollableHeight = wrapperScrollableHeight
    },
    handleClickOrderCount() {
      this.setPosSection('mobile-prepayment')
    },
    handleClickCategoryList() {
      this.setPosSection('mobile-category')
    },
    handleClickCloseSearch() {
      this.setPosDisplay({ search: false })
    },
    handleClickSearchIcon() {
      this.setPosDisplay({ search: true })
    },
    handleClickDiscountIcon() {
      this.setPosSection('mobile-discount')
    },
    handleClickNotificationIcon() {
      this.setPosSection('mobile-notification')
    },
  },
}
</script>

<style scoped>
.wrapper-choose-product {
  display: flex;
  flex-direction: column;
  background: #fff;
}

.header {
  display: flex;
  gap: 5px;
  padding: 5px;
  border-top: solid 2px #ebe8e8;
  height: var(--header-pos-height);
}

.header .btn-light, .header >>> .btn-light {
  width: 45px;
  height: 100%;
  color: #6c7a86;
  font-size: 20px;
  line-height: 22px;
}
.header .btn-light:active, .header .btn-light:hover {
  color: #6c7a86;
  background-color: #E5E5E5;
  border-color: inherit;
}

.header .btn-light i {
  position: relative;
  top: 1px;
}

.header .btn-order-number {
  font-weight: bold;
}

.header .btn-order-number.text-md {
  font-size: 17px;
}

.header .btn-order-number.text-sm {
  font-size: 14px;
}

.header .btn-submit-order {
  flex: 1;
  font-size: 20px;
  line-height: 22px;
}

.finding {
  display: flex;
  gap: 5px;
  align-items: center;
  padding: 12px;
  height: var(--header-pos-height);
  background: var(--bg-color);
}

.finding .category {
  flex: 1;
  gap: 10px;
  display: flex;
  align-items: center;
  color: #fff;
}

.finding .btn-icon {
  gap: 10px;
  display: flex;
  justify-content: end;
  align-items: center;
  color: #fff;
  position: relative;
}

.finding .text {
  flex: 1;
}

.finding .btn-icon .text {
  text-align: right;
}

.finding .icon {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.finding .category .icon {
  font-size: 12px;
}

.finding .btn-icon .icon {
  font-size: 14px;
}

.finding .btn-icon .icon  >>> .fa-bell {
  font-size: 16px !important;
}

.finding .search-input {
  flex: 1;
  display: flex;
  position: relative;
}

.finding .search-input input[type="text"] {
  touch-action: none;
  border: none;
  background: none;
  color: #000;
}

.finding .search-input input[type="text"]::placeholder {
  color: rgba(0,0,0,.3);
}

.finding .search-input .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  width: 30px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  color: #fff;
  background: none;
  border: none;
  outline: none;
}

.wrapper-sections {
  display: flex;
  flex-direction: column;
}

.wrapper-sections .btn-table {
  padding: 11px 0 !important;
}

.wrapper-sections .btn-dining .btn-dining {
  padding: 12px 0 10px 0 !important;
}

.wrapper-sections .btn-customer .btn-customer {
  padding: 12px 0 10px 0 !important;
}

.wrapper-sections .btn-table .text-right,
.wrapper-sections .btn-dining .text-right,
.wrapper-sections .btn-customer .text-right {
  position: relative;
  left: -7px;
}

.selection {
  display: flex;
  align-items: center;
  padding: 12px;
  height: var(--header-pos-height);
  border-bottom: solid 1px #ebe8e8;
}

.selection .text {
  flex: 1;
  font-size: 14px;
  color: #6c7a86;
}
.selection .icon {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ccc;
}

.wrapper-scrollable {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}

.wrapper-products {
  display: flex;
  flex-direction: column;
}

.product {
  display: flex;
  gap: 6px;
  padding: 12px;
  height: 80px;
  border-bottom: solid 1px #ebe8e8;
}

.vue-recycle-scroller__item-view:last-of-type .product {
  border-bottom: none;
}

.product .image {
  width: 60px;
  height: 100%;
}

.product .image img {
  height: 100%;
}

.product .detail {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.product .detail .info {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.product .detail .info .name {
  font-size: 16px;
}

.product .detail .info .icons {
  display: flex;
  gap: 4px;
}

.product .detail .price {
  text-align: right;
  font-size: 16px;
}

.sync-count {
  width: 18px;
  height: 18px;
  position: absolute;
  z-index: 1;
  top: 0;
  right: 3px;
  border-radius: 100%;
  background: #dc3545;
  color: #fff;
  font-size: 9px;
  text-align: center;
  line-height: 19px;
}

.scroller {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/mobile/include/ChooseProduct.vue